import React from 'react'
import {  AppHeader,AppContent,AppFooter} from '../index';

const DefaultLayout = () => {
  return (


    <><AppHeader /><main>
      <div className="section-wrapper section-content" style={{background:'#fff'}}>
        <div className="container-fluid">
          <div className="row">
            <AppContent/>
          </div>
        </div>
      </div>
      
    </main><AppFooter /></>

    
  )
}

export default DefaultLayout